<template>
  <div class="main-content" id="background">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6">
            <div class="text-center">
              <img class="navbar-brand-full" src="img/brand/logo_groony.png" width="52%" alt="Brain100studio Logo" />
            </div>
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <b-form @submit.prevent="submit">
                    <h4 class="text-center">{{$t('RESETPASSWORD')}}</h4>
                    <br />
                    <p class="text-center">{{$t('RESETMESSAGE')}}</p>
                    <b-row>
                      <b-col cols="12" class="text-center">
                        <b-button variant="primary" to="/login" class="px-4">{{$t('LOGIN')}}</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
 
<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "Success",
  data() {
    return {
      email: "",
      submitStatus: null
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    }
  },
  methods: {}
};
</script>
